import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=800ffab0&scoped=true&"
import script from "./scale.vue?vue&type=script&lang=js&"
export * from "./scale.vue?vue&type=script&lang=js&"
import style0 from "./scale.vue?vue&type=style&index=0&id=800ffab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800ffab0",
  null
  
)

export default component.exports